var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.bookingStatus == "PENDING"
    ? _c("span", { staticClass: "badge badge-info py-1 px-2" }, [
        _vm._v("Beklemede"),
      ])
    : _vm.bookingStatus == "OK" || _vm.bookingStatus == "SUCCESS"
    ? _c("span", { staticClass: "badge badge-success py-1 px-2" }, [
        _vm._v("Onaylandı"),
      ])
    : _vm.bookingStatus == "OK" ||
      _vm.bookingStatus == "SUCCESS" ||
      _vm.bookingStatus == "COMPLIMENTARY"
    ? _c(
        "span",
        {
          staticClass: "badge badge-success py-1 px-2",
          staticStyle: { "background-color": "#0d47a1" },
        },
        [_vm._v("Ücretsiz")]
      )
    : _vm.bookingStatus == "PARTIALLY_PAID"
    ? _c("span", { staticClass: "badge badge-info py-1 px-2" }, [
        _vm._v("Parçalı Ödeme"),
      ])
    : _vm.bookingStatus == "CANCELLED"
    ? _c("span", { staticClass: "badge badge-warning py-1 px-2" }, [
        _vm._v("İptal"),
      ])
    : _vm.bookingStatus == "NO_SHOW"
    ? _c("span", { staticClass: "badge badge-warning py-1 px-2" }, [
        _vm._v("No Show"),
      ])
    : _vm.bookingStatus == "FAILED"
    ? _c("span", { staticClass: "badge badge-warning py-1 px-2" }, [
        _vm._v("Başarısız"),
      ])
    : _vm.bookingStatus == "CREDIT_CARD"
    ? _c("span", { staticClass: "badge badge-info py-1 px-2" }, [
        _vm._v("Kredi Kartı"),
      ])
    : _vm.bookingStatus == "COUPON"
    ? _c("span", { staticClass: "badge badge-warning py-1 px-2" }, [
        _vm._v("Kupon"),
      ])
    : _c("span", { staticClass: "badge badge-light py-1 px-2" }, [
        _vm._v(_vm._s(_vm.bookingStatus)),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }